import {Injectable} from '@angular/core';
import { AuthService } from 'src/app/shared/auth.service';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}
// const NavigationItems=[
//   {
//     id: 'dashboard',
//     title: 'Dashboard',
//     type: 'item',
//     url: '/dashboard/analytics',
//     icon: 'insert_chart'
//   },
//   {
//     id: 'data-upload',
//     title: 'Data Upload',
//     type: 'item',
//     url: '/file-select',
//     target: false,
//     icon: 'upload_file'
//   },
//   {
//     id: 'results',
//     title: 'View Input/Output',
//     type: 'item',
//     url: '/results',
//     target: false,
//     icon: 'source'
//   },
//   {
//     id: 'user',
//     title: 'User',
//     type: 'item',
//     url: '/user',
//     target: false,
//     icon: 'person_outline'
//   },
//   {
//     id: 'role',
//     title: 'Dashboard Links',
//     type: 'item',
//     url: '/role',
//     target: false,
//     icon: 'link'
//   },
//   {
//     id: 'partner-setup',
//     title: 'Partner Setup',
//     type: 'item',
//     url: '/partner-setup',
//     target: false,
//     icon: 'handshake',
//   },
//   {
//     id: 'file-config',
//     title: 'File Configuration',
//     type: 'item',
//     url: '/file-config',
//     target: false,
//     icon: 'description'
//   }
// ]
const NavigationItems=[
  {
    id: 'dashboard',
    title: 'Dashboard',
    header:'',
    type: 'item',
    url: '/dashboard/analytics',
    icon: 'insert_chart'
  },
  {
    id: 'data-upload',
    title: 'Data Upload',
    header:'Data Upload',
    type: 'item',
    url: '/file-select',
    target: false,
    icon: 'upload_file'
  },
  {
    id: 'results',
    title: 'View Input/Output',
    header:'View Input/Output',
    type: 'item',
    url: '/results',
    target: false,
    icon: 'source'
  },
  {
    id: 'FAQs',
    title: 'FAQs',
    header:'Frequently Asked Questions',
    type: 'item',
    url: '/faqs',
    target: false,
    icon: 'quiz'
  },
  {
    id: 'partner-setup',
    title: 'Partner Setup',
    header:'Partner Setup',
    type: 'item',
    url: '/partner-setup',
    target: false,
    icon: 'handshake',
  },
  {
    id: 'file-config',
    title: 'File Configuration',
    header:'File Configuration',
    type: 'item',
    url: '/file-config',
    target: false,
    icon: 'description'
  },
  {
    id: 'user',
    title: 'User Control',
    header:'User Control',
    type: 'item',
    url: '/user',
    target: false,
    icon: 'person_outline'
  },
  {
    id: 'role',
    title: 'Dashboard Links',
    header:'Dashboard Links',
    type: 'item',
    url: '/role',
    target: false,
    icon: 'link'
  },
]
// const Nav = [
//   {
//     id: 'overview',
//     title: 'Overview',
//     type: 'group',
//     icon: 'toggle_on',
//     children: [
//       {
//         id: 'dashboard',
//         title: 'Dashboard',
//         type: 'item',
//         url: '/dashboard/analytics',
//         icon: 'insert_chart'
//       }   
//     ]
//   },
//   {
//     id: 'config',
//     title: 'Configuration',
//     type: 'group',
//     icon: 'toggle_on',
//     children: [
//       {
//         id: 'partner-setup',
//         title: 'Partner Setup',
//         type: 'item',
//         url: '/partner-setup',
//         target: false,
//         icon: 'handshake',
//       },
//       {
//         id: 'file-config',
//         title: 'File Configuration',
//         type: 'item',
//         url: '/file-config',
//         target: false,
//         icon: 'description'
//       },
//       // {
//       //   id: 'rule-config',
//       //   title: 'Rule Configuration',
//       //   type: 'item',
//       //   url: '/rule-config',
//       //   target: false,
//       //   icon: 'feather icon-layout',
//       // }
//     ]
//   },
//   {
//     id: 'processing',
//     title: 'Processing',
//     type: 'group',
//     icon: 'account_tree',
//     children: [
//       {
//         id: 'data-upload',
//         title: 'Data Upload',
//         type: 'item',
//         url: '/file-select',
//         target: false,
//         icon: 'upload_file'
//       },
//       {
//         id: 'results',
//         title: 'View Input/Output',
//         type: 'item',
//         url: '/results',
//         target: false,
//         icon: 'source'
//       },
//       // {
//       //   id: 'faqs',
//       //   title: 'faqs',
//       //   type: 'item',
//       //   url: '/faqs',
//       //   target: false,
//       //   icon: 'feather icon-layout'
//       // }
//     ]
//   },
//   {
//     id: 'admin',
//     title: 'Admin',
//     type: 'group',
//     icon: 'person',
//     children: [
//       {
//         id: 'user',
//         title: 'User',
//         type: 'item',
//         url: '/user',
//         target: false,
//         icon: 'person_outline'
//       },
//       {
//         id: 'role',
//         title: 'Dashboard Links',
//         type: 'item',
//         url: '/role',
//         target: false,
//         icon: 'link'
//       },
//       // {
//         // id: 'ftp',
//         // title: 'FTP',
//         // type: 'item',
//         // url: '/ftp',
//         // target: false,
//         // icon: 'feather icon-layout'
//       // },
   
//      ]
//    }
//   // {
//   //   id: 'ui-element',
//   //   title: 'UI ELEMENT & FORMS',
//   //   type: 'group',
//   //   icon: 'feather icon-layers',
//   //   children: [
//   //     {
//   //       id: 'basic',
//   //       title: 'Basic',
//   //       type: 'collapse',
//   //       icon: 'feather icon-box',
//   //       children: [
//   //         {
//   //           id: 'alert',
//   //           title: 'Alert',
//   //           type: 'item',
//   //           url: '/basic/alert'
//   //         },
//   //         {
//   //           id: 'button',
//   //           title: 'Button',
//   //           type: 'item',
//   //           url: '/basic/button'
//   //         },
//   //         {
//   //           id: 'badges',
//   //           title: 'Badges',
//   //           type: 'item',
//   //           url: '/basic/badges'
//   //         },
//   //         {
//   //           id: 'breadcrumb-pagination',
//   //           title: 'Breadcrumbs & Pagination',
//   //           type: 'item',
//   //           url: '/basic/breadcrumb-paging'
//   //         },
//   //         {
//   //           id: 'cards',
//   //           title: 'Cards',
//   //           type: 'item',
//   //           url: '/basic/cards'
//   //         },
//   //         {
//   //           id: 'collapse',
//   //           title: 'Collapse',
//   //           type: 'item',
//   //           url: '/basic/collapse'
//   //         },
//   //         {
//   //           id: 'carousel',
//   //           title: 'Carousel',
//   //           type: 'item',
//   //           url: '/basic/carousel'
//   //         },
//   //         {
//   //           id: 'grid-system',
//   //           title: 'Grid System',
//   //           type: 'item',
//   //           url: '/basic/grid-system'
//   //         },
//   //         {
//   //           id: 'progress',
//   //           title: 'Progress',
//   //           type: 'item',
//   //           url: '/basic/progress'
//   //         },
//   //         {
//   //           id: 'modal',
//   //           title: 'Modal',
//   //           type: 'item',
//   //           url: '/basic/modal'
//   //         },
//   //         {
//   //           id: 'spinner',
//   //           title: 'Spinner',
//   //           type: 'item',
//   //           url: '/basic/spinner'
//   //         },
//   //         {
//   //           id: 'tabs-pills',
//   //           title: 'Tabs & Pills',
//   //           type: 'item',
//   //           url: '/basic/tabs-pills'
//   //         },
//   //         {
//   //           id: 'typography',
//   //           title: 'Typography',
//   //           type: 'item',
//   //           url: '/basic/typography'
//   //         },
//   //         {
//   //           id: 'tooltip-popovers',
//   //           title: 'Tooltip & Popovers',
//   //           type: 'item',
//   //           url: '/basic/tooltip-popovers'
//   //         },
//   //         {
//   //           id: 'other',
//   //           title: 'Other',
//   //           type: 'item',
//   //           url: '/basic/other'
//   //         }
//   //       ]
//   //     },
//   //     {
//   //       id: 'forms-element',
//   //       title: 'Form Elements',
//   //       type: 'item',
//   //       url: '/forms/basic',
//   //       icon: 'feather icon-file-text'
//   //     }
      
//   //   ]
//   // },
//   // {
//   //   id: 'table',
//   //   title: 'Table & Charts',
//   //   type: 'group',
//   //   icon: 'feather icon-list',
//   //   children: [
//   //     {
//   //       id: 'bootstrap',
//   //       title: 'Bootstrap Table',
//   //       type: 'item',
//   //       url: '/tbl-bootstrap/bt-basic',
//   //       icon: 'feather icon-server'
//   //     },
//   //     {
//   //       id: 'apex',
//   //       title: 'Apex Chart',
//   //       type: 'item',
//   //       url: '/charts/apex',
//   //       icon: 'feather icon-pie-chart'
//   //     }
//   //   ]
//   // },
//   // {
//   //   id: 'pages',
//   //   title: 'Pages',
//   //   type: 'group',
//   //   icon: 'feather icon-file-text',
//   //   children: [
//   //     {
//   //       id: 'auth',
//   //       title: 'Authentication',
//   //       type: 'collapse',
//   //       icon: 'feather icon-lock',
//   //       children: [
//   //         {
//   //           id: 'signup',
//   //           title: 'Sign up',
//   //           type: 'item',
//   //           url: '/auth/signup',
//   //           target: true,
//   //           breadcrumbs: false
//   //         },
//   //         {
//   //           id: 'signin',
//   //           title: 'Sign in',
//   //           type: 'item',
//   //           url: '/auth/signin',
//   //           target: true,
//   //           breadcrumbs: false
//   //         },
//   //         {
//   //           id: 'reset-password',
//   //           title: 'Reset Password',
//   //           type: 'item',
//   //           url: '/auth/reset-password',
//   //           target: true,
//   //           breadcrumbs: false
//   //         },
//   //         {
//   //           id: 'change-password',
//   //           title: 'Change Password',
//   //           type: 'item',
//   //           url: '/auth/change-password',
//   //           target: true,
//   //           breadcrumbs: false
//   //         }
//   //       ]
//   //     },
//   //     {
//   //       id: 'maintenance',
//   //       title: 'Maintenance',
//   //       type: 'collapse',
//   //       icon: 'feather icon-sliders',
//   //       children: [
//   //         {
//   //           id: 'error',
//   //           title: 'Error',
//   //           type: 'item',
//   //           url: '/maintenance/error',
//   //           target: true,
//   //           breadcrumbs: false
//   //         },
//   //         {
//   //           id: 'coming-soon',
//   //           title: 'Maintenance',
//   //           type: 'item',
//   //           url: '/maintenance/coming-soon',
//   //           target: true,
//   //           breadcrumbs: false
//   //         }
//   //       ]
//   //     }
//   //   ]
//   // },
//   // {
//   //   id: 'other',
//   //   title: 'Other',
//   //   type: 'group',
//   //   icon: 'feather icon-align-left',
//   //   children: [
//   //     {
//   //       id: 'menu-level',
//   //       title: 'Menu Levels',
//   //       type: 'collapse',
//   //       icon: 'feather icon-menu',
//   //       children: [
//   //         {
//   //           id: 'menu-level-2.1',
//   //           title: 'Menu Level 2.1',
//   //           type: 'item',
//   //           url: 'javascript:',
//   //           external: true
//   //         },
//   //         {
//   //           id: 'menu-level-2.2',
//   //           title: 'Menu Level 2.2',
//   //           type: 'collapse',
//   //           children: [
//   //             {
//   //               id: 'menu-level-2.2.1',
//   //               title: 'Menu Level 2.2.1',
//   //               type: 'item',
//   //               url: 'javascript:',
//   //               external: true
//   //             },
//   //             {
//   //               id: 'menu-level-2.2.2',
//   //               title: 'Menu Level 2.2.2',
//   //               type: 'item',
//   //               url: 'javascript:',
//   //               external: true
//   //             }
//   //           ]
//   //         }
//   //       ]
//   //     },
//   //     {
//   //       id: 'disabled-menu',
//   //       title: 'Disabled Menu',
//   //       type: 'item',
//   //       url: 'javascript:',
//   //       classes: 'nav-item disabled',
//   //       icon: 'feather icon-power',
//   //       external: true
//   //     },
//   //     {
//   //       id: 'sample-page',
//   //       title: 'Sample Page',
//   //       type: 'item',
//   //       url: '/sample-page',
//   //       classes: 'nav-item',
//   //       icon: 'feather icon-sidebar'
//   //     }
//   //   ]
//   // }
// ];

const OperationItems = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    header:'',
    type: 'item',
    url: '/dashboard/analytics',
    icon: 'insert_chart'
  },
  {
    id: 'data-upload',
    title: 'Data Upload',
    header:'Data Upload',
    type: 'item',
    url: '/file-select',
    target: false,
    icon: 'upload_file'
  },
  {
    id: 'results',
    title: 'View Input/Output',
    header:'View Input/Output',
    type: 'item',
    url: '/results',
    target: false,
    icon: 'source'
  }
]

 const customMenu=[
        {
          id: 'dashboard',
          title: 'Dashboard',
          header:'',
          type: 'item',
          url: '/dashboard/analytics',
          icon: 'insert_chart'
        },
        {
          id: 'data-upload',
          title: 'Data Upload',
          header:'Data Upload',
          type: 'item',
          url: '/file-select',
          target: false,
          icon: 'upload_file'
        },
        {
          id: 'results',
          title: 'View Input/Output',
          header:'View Input/Output',
          type: 'item',
          url: '/results',
          target: false,
          icon: 'source'
        },
        {
          id: 'FAQs',
          title: 'FAQs',
          header:'',
          type: 'item',
          url: '/faqs',
          target: false,
          icon: 'quiz'
        },
        {
          id: 'partner-setup',
          title: 'Partner Setup',
          header:'Partner Setup',
          type: 'item',
          url: '/partner-setup',
          target: false,
          icon: 'handshake',
        },
        {
          id: 'file-config',
          title: 'File Configuration',
          header:'File Configuration',
          type: 'item',
          url: '/file-config',
          target: false,
          icon: 'description'
        },
        {
          id: 'user',
          title: 'User Control',
          header:'User Control',
          type: 'item',
          url: '/user',
          target: false,
          icon: 'person_outline'
        },
        {
          id: 'role',
          title: 'Dashboard Links',
          header:'Dashboard Links',
          type: 'item',
          url: '/role',
          target: false,
          icon: 'link'
        },
      ]

@Injectable()
export class NavigationItem {
  eachItem:any=[]
  count:number=0
  data:any
  // object
  
  constructor(private authservice: AuthService) { }
  public getCustom(){
    return customMenu;
  }
  public get() {
    var NavigationData =[];
    var role = localStorage.getItem('role')
    if(role == "admin"){
      //console.log(this.count++)
      return NavigationItems;
    }
    if(role=="custom"){
      // const items=[]
      this.data=JSON.parse(localStorage.getItem("completeUserObject"))
      const item=this.data.Menu_list.split(",")
      const eachItem=[]
        item.forEach((each)=>{
        // console.log(NavigationItems)
         const [data]=customMenu.filter((element)=>{
          //  console.log(element.title,each)
          return element.title==each
         })
        //  console.log(data)
         eachItem.push(data)
       })
       const [object]=eachItem
       console.log(eachItem,object)
      return eachItem;
    }
    
    if(role=="operations"){
      return OperationItems
    }
    if(role=="partner"){
      return  NavigationData = [
        {
          id: 'dashboard',
          title: 'Dashboard',
          header:'',
          type: 'item',
          url: '/dashboard/analytics',
          icon: 'insert_chart'
        },
        
        {
          id: 'results',
          title: 'View Input/Output',
          header:'View Input/Output',
          type: 'item',
          url: '/results',
          target: false,
          icon: 'source'
        }
        // {
        //   id: 'overview',
        //   title: 'Overview',
        //   type: 'group',
        //   icon: 'feather icon-monitor',
        //   children: [
        //     {
        //       id: 'dashboard',
        //       title: 'Dashboard',
        //       type: 'item',
        //       url: '/dashboard/analytics',
        //       icon: 'insert_chart'
        //     }   
        //   ]
        // },
        // {
        //   id: 'config',
        //   title: 'Configuration',
        //   type: 'group',
        //   icon: 'feather icon-monitor',
        //   children: [
        //     {
        //       id: 'partner-setup',
        //       title: 'Partner Setup',
        //       type: 'item',
        //       url: '/partner-setup',
        //       target: false,
        //       icon: 'feather icon-layout'
        //     },
        //     {
        //       id: 'file-config',
        //       title: 'File Configuration',
        //       type: 'item',
        //       url: '/file-config',
        //       target: false,
        //       icon: 'feather icon-layout'
        //     },
            // {
            //   id: 'rule-config',
            //   title: 'Rule Configuration',
            //   type: 'item',
            //   url: '/rule-config',
            //   target: false,
            //   icon: 'feather icon-layout',
            // }
        //   ]
        // },
        //  {
        //   id: 'processing',
        //   title: 'Processing',
        //   type: 'group',
        //   icon: 'feather icon-monitor',
        //   children: [
            // {
            //   id: 'data-upload',
            //   title: 'Data Upload',
            //   type: 'item',
            //   url: '/file-select',
            //   target: false,
            //   icon: 'feather icon-layout'
            // },
            // {
            //   id: 'results',
            //   title: 'View Input/Output',
            //   type: 'item',
            //   url: '/results',
            //   target: false,
            //   icon: 'source'
            // },
            // {
            //   id: 'faqs',
            //   title: 'faqs',
            //   type: 'item',
            //   url: '/faqs',
            //   target: false,
            //   icon: 'feather icon-layout'
            // }
          ]
        // },
        // {
        //   id: 'admin',
        //   title: 'Admin',
        //   type: 'group',
        //   icon: 'feather icon-monitor',
        //   children: [
        //     {
        //       id: 'user',
        //       title: 'User',
        //       type: 'item',
        //       url: '/user',
        //       target: false,
        //       icon: 'feather icon-layout'
        //     },
        //     {
        //       id: 'role',
        //       title: 'Role',
        //       type: 'item',
        //       url: '/role',
        //       target: false,
        //       icon: 'feather icon-layout'
        //     },
         
        //    ]
        //  }
        // {
        //   id: 'ui-element',
        //   title: 'UI ELEMENT & FORMS',
        //   type: 'group',
        //   icon: 'feather icon-layers',
        //   children: [
        //     {
        //       id: 'basic',
        //       title: 'Basic',
        //       type: 'collapse',
        //       icon: 'feather icon-box',
        //       children: [
        //         {
        //           id: 'alert',
        //           title: 'Alert',
        //           type: 'item',
        //           url: '/basic/alert'
        //         },
        //         {
        //           id: 'button',
        //           title: 'Button',
        //           type: 'item',
        //           url: '/basic/button'
        //         },
        //         {
        //           id: 'badges',
        //           title: 'Badges',
        //           type: 'item',
        //           url: '/basic/badges'
        //         },
        //         {
        //           id: 'breadcrumb-pagination',
        //           title: 'Breadcrumbs & Pagination',
        //           type: 'item',
        //           url: '/basic/breadcrumb-paging'
        //         },
        //         {
        //           id: 'cards',
        //           title: 'Cards',
        //           type: 'item',
        //           url: '/basic/cards'
        //         },
        //         {
        //           id: 'collapse',
        //           title: 'Collapse',
        //           type: 'item',
        //           url: '/basic/collapse'
        //         },
        //         {
        //           id: 'carousel',
        //           title: 'Carousel',
        //           type: 'item',
        //           url: '/basic/carousel'
        //         },
        //         {
        //           id: 'grid-system',
        //           title: 'Grid System',
        //           type: 'item',
        //           url: '/basic/grid-system'
        //         },
        //         {
        //           id: 'progress',
        //           title: 'Progress',
        //           type: 'item',
        //           url: '/basic/progress'
        //         },
        //         {
        //           id: 'modal',
        //           title: 'Modal',
        //           type: 'item',
        //           url: '/basic/modal'
        //         },
        //         {
        //           id: 'spinner',
        //           title: 'Spinner',
        //           type: 'item',
        //           url: '/basic/spinner'
        //         },
        //         {
        //           id: 'tabs-pills',
        //           title: 'Tabs & Pills',
        //           type: 'item',
        //           url: '/basic/tabs-pills'
        //         },
        //         {
        //           id: 'typography',
        //           title: 'Typography',
        //           type: 'item',
        //           url: '/basic/typography'
        //         },
        //         {
        //           id: 'tooltip-popovers',
        //           title: 'Tooltip & Popovers',
        //           type: 'item',
        //           url: '/basic/tooltip-popovers'
        //         },
        //         {
        //           id: 'other',
        //           title: 'Other',
        //           type: 'item',
        //           url: '/basic/other'
        //         }
        //       ]
        //     },
        //     {
        //       id: 'forms-element',
        //       title: 'Form Elements',
        //       type: 'item',
        //       url: '/forms/basic',
        //       icon: 'feather icon-file-text'
        //     }
            
        //   ]
        // },
        // {
        //   id: 'table',
        //   title: 'Table & Charts',
        //   type: 'group',
        //   icon: 'feather icon-list',
        //   children: [
        //     {
        //       id: 'bootstrap',
        //       title: 'Bootstrap Table',
        //       type: 'item',
        //       url: '/tbl-bootstrap/bt-basic',
        //       icon: 'feather icon-server'
        //     },
        //     {
        //       id: 'apex',
        //       title: 'Apex Chart',
        //       type: 'item',
        //       url: '/charts/apex',
        //       icon: 'feather icon-pie-chart'
        //     }
        //   ]
        // },
        // {
        //   id: 'pages',
        //   title: 'Pages',
        //   type: 'group',
        //   icon: 'feather icon-file-text',
        //   children: [
        //     {
        //       id: 'auth',
        //       title: 'Authentication',
        //       type: 'collapse',
        //       icon: 'feather icon-lock',
        //       children: [
        //         {
        //           id: 'signup',
        //           title: 'Sign up',
        //           type: 'item',
        //           url: '/auth/signup',
        //           target: true,
        //           breadcrumbs: false
        //         },
        //         {
        //           id: 'signin',
        //           title: 'Sign in',
        //           type: 'item',
        //           url: '/auth/signin',
        //           target: true,
        //           breadcrumbs: false
        //         },
        //         {
        //           id: 'reset-password',
        //           title: 'Reset Password',
        //           type: 'item',
        //           url: '/auth/reset-password',
        //           target: true,
        //           breadcrumbs: false
        //         },
        //         {
        //           id: 'change-password',
        //           title: 'Change Password',
        //           type: 'item',
        //           url: '/auth/change-password',
        //           target: true,
        //           breadcrumbs: false
        //         }
        //       ]
        //     },
        //     {
        //       id: 'maintenance',
        //       title: 'Maintenance',
        //       type: 'collapse',
        //       icon: 'feather icon-sliders',
        //       children: [
        //         {
        //           id: 'error',
        //           title: 'Error',
        //           type: 'item',
        //           url: '/maintenance/error',
        //           target: true,
        //           breadcrumbs: false
        //         },
        //         {
        //           id: 'coming-soon',
        //           title: 'Maintenance',
        //           type: 'item',
        //           url: '/maintenance/coming-soon',
        //           target: true,
        //           breadcrumbs: false
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   id: 'other',
        //   title: 'Other',
        //   type: 'group',
        //   icon: 'feather icon-align-left',
        //   children: [
        //     {
        //       id: 'menu-level',
        //       title: 'Menu Levels',
        //       type: 'collapse',
        //       icon: 'feather icon-menu',
        //       children: [
        //         {
        //           id: 'menu-level-2.1',
        //           title: 'Menu Level 2.1',
        //           type: 'item',
        //           url: 'javascript:',
        //           external: true
        //         },
        //         {
        //           id: 'menu-level-2.2',
        //           title: 'Menu Level 2.2',
        //           type: 'collapse',
        //           children: [
        //             {
        //               id: 'menu-level-2.2.1',
        //               title: 'Menu Level 2.2.1',
        //               type: 'item',
        //               url: 'javascript:',
        //               external: true
        //             },
        //             {
        //               id: 'menu-level-2.2.2',
        //               title: 'Menu Level 2.2.2',
        //               type: 'item',
        //               url: 'javascript:',
        //               external: true
        //             }
        //           ]
        //         }
        //       ]
        //     },
        //     {
        //       id: 'disabled-menu',
        //       title: 'Disabled Menu',
        //       type: 'item',
        //       url: 'javascript:',
        //       classes: 'nav-item disabled',
        //       icon: 'feather icon-power',
        //       external: true
        //     },
        //     {
        //       id: 'sample-page',
        //       title: 'Sample Page',
        //       type: 'item',
        //       url: '/sample-page',
        //       classes: 'nav-item',
        //       icon: 'feather icon-sidebar'
        //     }
        //   ]
        //  }
      //  ];
    }
   
  }
}
